import { googleStartUrl } from "../../api/auth-api.js";
import { markFreshAuthentication } from "../organizations/workspace-entry.js";

export function startGoogleAuthentication(input: {
  preferRedirect: boolean;
  startPopup: () => void;
  returnPath?: string;
}): void {
  if (input.preferRedirect) {
    markFreshAuthentication();
    window.location.href = googleStartUrl("redirect", input.returnPath ?? "/");
    return;
  }
  input.startPopup();
}
